import React, { type ReactEventHandler, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { isRebrandingQuotaLanding } from 'reactApp/appHelpers/featuresHelpers';
import { autoUploadPromo } from 'reactApp/appHelpers/featuresHelpers/features/autoUploadPromo';
import { isPromoQuotaWithLitress } from 'reactApp/appHelpers/featuresHelpers/features/litres';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { TariffSwitch } from 'reactApp/ui/TariffCardNew/components/TariffSwitch';
import type { SwitchOption } from 'reactApp/ui/TariffCardNew/components/TariffSwitch.types';
import { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';

const switchOptions: [SwitchOption, SwitchOption] = [
    {
        value: ETabsName.month,
        text: 'На месяц',
    },
    {
        value: ETabsName.year,
        text: 'На год',
    },
];

interface Props {
    checkedOption: ETabsName;
    onClickSwitch: (tab: ETabsName) => void;
    isReferral?: boolean;
}

export const TariffPeriodSwitch = ({ checkedOption, onClickSwitch, isReferral }: Props) => {
    const onTariffSwitchClick: ReactEventHandler = useCallback(
        (event) => {
            event.stopPropagation();
            onClickSwitch(checkedOption === ETabsName.year ? ETabsName.month : ETabsName.year);
        },
        [checkedOption, onClickSwitch]
    );

    const isPaid = useSelector(UserSelectors.isPaidUser);
    return (
        <TariffSwitch
            dark
            checked={checkedOption === ETabsName.year}
            onClick={onTariffSwitchClick}
            options={switchOptions}
            isRebrandingQuotaLanding={isRebrandingQuotaLanding}
            isFromLitres={isPromoQuotaWithLitress && !isPaid}
            fromLanding
            // tempexp_18086-next-line
            black={isReferral || autoUploadPromo}
        />
    );
};
